module.exports = __webpack_public_path__ + "img/125837d.png";